import Cookies from 'js-cookie';

export const doesCustomerExist = () => {
  if (!Cookies.get('customerToken')) {
    return false;
  }
  return true;
};

export const getCustomerName = (customer) => {
  const { firstName, lastName } = customer;

  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }

  if (firstName) {
    return firstName;
  }

  if (lastName) {
    return lastName;
  }

  return '';
};

export const getCustomerGivenNames = (fullName, t) => {
  if (!fullName) {
    throw new Error(t('general.errorMessages.invalidName'));
  }

  const nameArray = fullName.split(' ');

  if (nameArray.length < 2) {
    throw new Error(t('general.errorMessages.invalidNameFormat'));
  }

  const firstName = nameArray.shift();
  const lastName = nameArray.join(' ');

  return { firstName, lastName };
};
